import { render, staticRenderFns } from "./LiceseImgPriview.vue?vue&type=template&id=0d11d12a&scoped=true&"
import script from "./LiceseImgPriview.vue?vue&type=script&lang=ts&"
export * from "./LiceseImgPriview.vue?vue&type=script&lang=ts&"
import style0 from "./LiceseImgPriview.vue?vue&type=style&index=0&id=0d11d12a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d11d12a",
  null
  
)

export default component.exports